export default __webpack_public_path__ + "static/media/mc.97962231.svg";